import * as React from 'react';
import { IDatepickerContext } from './types';

export const DatepickerContext = React.createContext<IDatepickerContext>(null);
